/**
 * Minimal deadline identity for public-id lookup.
 *
 * `id` and `event_guid` are typically both the synthetic deadline id.
 * `base_event_guids` are collapsed evidence Event.guids — the ids that
 * PDF highlights, assignment emails, and notifications still carry.
 */
export type DeadlinePublicIdMatch = {
  id: string;
  event_guid?: string;
  base_event_guids?: string[];
};

/**
 * Resolve a public / annotation id to a deadline row.
 *
 * Matches `id`, `event_guid`, or any collapsed `base_event_guids` entry so
 * deep links and legacy PDF `taskId`s (Event.guid) find the synthetic row.
 */
export function findDeadlineByPublicId<T extends DeadlinePublicIdMatch>(
  deadlines: readonly T[] | null | undefined,
  publicId: string | null | undefined,
): T | undefined {
  if (!deadlines || !publicId) return undefined;
  return deadlines.find(
    (deadline) =>
      deadline.id === publicId
      || deadline.event_guid === publicId
      || (deadline.base_event_guids?.includes(publicId) ?? false),
  );
}
